"use strict";
"use client";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { Switch } from '@ark-ui/react/switch';
export { SwitchContext as Context, SwitchHiddenInput as HiddenInput } from '@ark-ui/react/switch';
import { withSlotScopeClasses } from '../../helpers/scoped-slots.mjs';
import { tv } from 'tailwind-variants';
import { createSlotRecipeContext } from './utils/create-slot-recipe-context.mjs';

const switchRecipeTv = tv({
  slots: withSlotScopeClasses("switchRecipe", {
    root: "items-center flex relative",
    control: [
      "items-center bg-bg-emphasized rounded-full cursor-pointer inline-flex flex-shrink-0",
      "transition-[background] duration-200",
      "data-[state=checked]:bg-grass-9"
    ],
    label: "text-fg-default font-medium",
    thumb: [
      "bg-bg-default rounded-full shadow-xs",
      "transition-[transform,background] duration-200",
      "data-[state=checked]:translate-x-full",
      "data-[state=checked]:bg-bg-default [[data-iap-color-mode=dark]_&]:data-[state=checked]:bg-neutral-fg"
    ]
  }),
  variants: {
    size: {
      sm: {
        root: "gap-2",
        control: "w-7 p-0.5",
        thumb: "w-3 h-3",
        label: "text-sm leading-5"
      },
      md: {
        root: "gap-3",
        control: "w-9 p-0.5",
        thumb: "w-4 h-4",
        label: "text-base leading-6"
      },
      lg: {
        root: "gap-4",
        control: "w-11 p-0.5",
        thumb: "w-5 h-5",
        label: "text-lg leading-7"
      }
    }
  },
  defaultVariants: {
    size: "md"
  }
});
const { withProvider, withContext } = createSlotRecipeContext(switchRecipeTv);
withProvider(Switch.RootProvider, "root");
const Root = withProvider(Switch.Root, "root");
const Control = withContext(
  Switch.Control,
  "control"
);
const Label = withContext(Switch.Label, "label");
const Thumb = withContext(Switch.Thumb, "thumb");

export { Control, Label, Root, Thumb };
